import { Dialog, Transition } from '@headlessui/react';
import { Fragment } from 'react';

import Button from '../Button';

import { Props } from './types';

/**
 * @deprecated Do not use this component. Use the base components at the root of the UI folder instead.
 */
const Modal = ({
  backgroundColor = 'bg-gray-500/60',
  blurredBackground = false,
  button,
  dismissButton,
  icon,
  iconBackgroundColor,
  onClose,
  open,
  overflowVisible = false,
  restrictCloseToButton = false,
  textContent,
  children,
  title,
  dataTestId
}: Props) => {
  return (
    <Transition show={open} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-30"
        data-testid={dataTestId}
        onClose={() => {
          if (!restrictCloseToButton) onClose();
        }}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0">
          <div
            className={`fixed inset-0 ${backgroundColor} bg-opacity-60 transition-opacity${
              blurredBackground ? ' backdrop-blur-xs' : ''
            }`}
          />
        </Transition.Child>

        <div className="fixed inset-0 z-10 w-screen overflow-hidden">
          <div className="flex min-h-full justify-center p-4 text-center items-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
              <Dialog.Panel
                className={`relative transform ${overflowVisible ? 'overflow-visible' : 'overflow-y-auto'} rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6 max-h-[calc(100vh-2rem)]`}>
                <div>
                  {!!icon && (
                    <div
                      className={`mx-auto flex h-12 w-12 items-center justify-center rounded-full${
                        iconBackgroundColor ? ` ${iconBackgroundColor}` : ''
                      }`}>
                      {icon}
                    </div>
                  )}
                  <div className="mt-1 text-center sm:mt-1">
                    {!!title && (
                      <Dialog.Title
                        as="h3"
                        className="text-base font-semibold leading-6 text-gray-900">
                        {title}
                      </Dialog.Title>
                    )}
                    <div className="mt-2">
                      {!!textContent &&
                        (typeof textContent === 'string' ? (
                          <p className="text-sm text-gray-500">{textContent}</p>
                        ) : (
                          textContent
                        ))}
                    </div>
                  </div>
                </div>
                {children}

                {button && (
                  <div
                    className={
                      dismissButton
                        ? 'mt-5 sm:mt-6 sm:grid sm:grid-flow-row-dense sm:grid-cols-2 sm:gap-3'
                        : 'mt-5 sm:mt-6'
                    }>
                    <Button
                      className={
                        dismissButton
                          ? 'inline-flex w-full justify-center sm:col-start-2'
                          : 'w-full'
                      }
                      {...button}
                      onClick={button.onClick ?? onClose}>
                      {button.children}
                    </Button>
                    {dismissButton && (
                      <Button
                        className="mt-3 inline-flex w-full justify-center sm:col-start-1 sm:mt-0"
                        {...dismissButton}
                        onClick={dismissButton.onClick ?? onClose}>
                        {dismissButton.children}
                      </Button>
                    )}
                  </div>
                )}
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
};

export default Modal;
